import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type User from "./User";

@Model()
class JournalistEnquiryEntry extends ApplicationRecord {
  static jsonapiType = "journalist_enquiry_entries";

  @Attr({ persist: false }) createdAt: string;

  @Attr() journalistEnquiryId: number;

  @Attr() text: string;

  @BelongsTo() user: User;

  @Attr() userId: number;
}

export default JournalistEnquiryEntry;
